import { HttpClient } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
@Component({
  selector: 'app-job-complete-cofirmation-modal',
  templateUrl: './job-complete-cofirmation-modal.component.html',
  styleUrl: './job-complete-cofirmation-modal.component.css',
})
export class JobCompleteCofirmationModalComponent {
  @Input() jobId: string = '';
  constructor(
    public activeModal: NgbActiveModal,
    public http: HttpClient,
    private toastr: ToastrService,

    private auth: AuthServiceService
  ) {}

  jobNotComplete = this.close;
  jobIsComplete() {
    this.auth.set_telegram_job_is_completed(this.jobId).subscribe(
      (data) => {
        this.toastr.show('Job complete!');
        this.close();
      },
      (err) => {
        this.toastr.error('Error something went wrong please try again latter');
      }
    );
  }
  close(): void {
    this.activeModal.dismiss();
  }
}
